export default "/static/liconic_str_tiny.png";